export default __webpack_public_path__ + "static/moodyman_background-051775f5d6501122d65e588c70da871f.png";